import { IInputModel, IOptions } from 'app/interfaces/input/input.interface';
import ImagePath from 'app/utilities/imagePath';
import React, { ReactElement, useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import DatePicker from "react-datepicker";
import { phoneFormatRegex } from '../../../constants/regex';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';
import './InputComponent.scss';
import "react-datepicker/dist/react-datepicker.css";

/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Option = function init(props: any): ReactElement {
	const { isSelected, label, id } = props;
	return (
		<div>
			<components.Option {...props}>
				<input
					type="checkbox"
					checked={isSelected}
					onChange={() => null}
				/>
				<label htmlFor={id}>{label}</label>
			</components.Option>
		</div>
	);
};
const InputComponent = function init(props: IInputModel): React.ReactElement {
	const {
		id,
		placeholder,
		formType,
		name,
		apiErrorMessage,
		options,
		value,
		loading,
		disabled,
		onChange,
	}: IInputModel = props;
	const [passwordShown, setPasswordShown] = useState(false);
	const [error, setError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [inputValue, setInputValue] = useState(value);
	const [readOnly, setReadOnly] = useState(true);
	const [isDisabled, setDisable] = useState(false);
	const eyeImage = passwordShown ? ImagePath.eyeOpen : ImagePath.eyeClosed;
	const [multiSelectValue, setMultiSelectValue] = useState({ optionSelected: null });
	const [dateRange, setDateRange] = useState([null, null]);
	const [startDate, endDate] = dateRange;

	function togglePasswordVisiblity(): void {
		setPasswordShown(!passwordShown);
	}

	function checkError(val: string): void {
		switch (formType) {
			case 'phone':
				if (val) {
					if (phoneFormatRegex.test(val)) {
						setError(false);
						setErrorMessage('');
						break;
					}
					setError(true);
					setErrorMessage('Format Nomor Handphone salah');
				}
				break;
			case 'password':
				break;
			case 'select':
				break;
			default:
				break;
		}
	}

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	useEffect(() => {
		if (!value) {
			setDateRange([null, null]);
			setMultiSelectValue({ optionSelected: null });
		}
	}, [value]);

	useEffect(() => {
		if (formType === 'datePicker') {
			setInputValue(startDate ?? '');
		}
	}, [startDate]);

	useEffect(() => {
		setDisable(disabled || false);
	}, [disabled]);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function thousandSeparator(val: any): string {
		const res = val.toString().replace(/[^0-9]/g, '');
		return res.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function handleOnChange(val: any): void {
		// const tempVal = formType === 'select' ? val.value : val;
		let tempVal;
		let multiVal: string[] = [];
		switch (formType) {
			case 'select':
				tempVal = val.value;
				break;
			case 'datePicker':
				tempVal = Array.isArray(val)
				? val.map((date) => (date ? Math.floor(new Date(date).getTime() / 1000) : null))
				: [Math.floor(new Date(val).getTime() / 1000), null];
				break;
			case 'currency':
				const reg = /^0+/gi;
				if (val.match(reg)) {
					val = val.replace(reg, '');
				}
				tempVal = thousandSeparator(val);
				break;
			case 'multi-select':
				setMultiSelectValue({
					optionSelected: val
				});
				multiVal = val.map((item: IOptions) => item.value.toString());
				tempVal = val;
				break;
			case 'number':
				const numReg = /[^0-9]/g;
				if (val.match(numReg)) {
					val = val.replace(numReg, '');
				}
				tempVal = val;
				break;
			default:
				tempVal = val;
				break;
		}
		setInputValue(tempVal);
		setError(false);
		setErrorMessage('');
		checkError(val);
		if (onChange) {
			const payload = {
				name,
				value: multiVal.length > 0 ? multiVal.toString() : tempVal,
			};
			onChange(payload);
		}
	}

	function switchForm(type: string): ReactElement {
		switch (type) {
			case 'phone':
				return (
					<div className="input-container">
						<p>{placeholder}</p>
						<input
							id={id}
							className="input-group prefix-addon"
							placeholder={`+62 ${placeholder}`}
							name={name}
							onChange={(event) => handleOnChange(event.target.value)}
							value={value !== undefined ? inputValue : undefined}
							readOnly={readOnly}
							onFocus={() => setReadOnly(false)}
							onBlur={() => setReadOnly(true)}
							disabled={isDisabled}
						/>
						{/* <span className="prefix">
							{prefix}
						</span> */}
					</div>
				);
			case 'password':
				return (
					<div className="input-container">
						<p>{placeholder}</p>
						<input
							id={id}
							type={passwordShown ? 'text' : 'password'}
							className="input-group postfix-addon"
							placeholder={placeholder}
							name={name}
							onChange={(event) => handleOnChange(event.target.value)}
							value={value !== undefined ? inputValue : undefined}
							disabled={isDisabled}
						/>
						<button
							type="button"
							className="postfix"
							onClick={togglePasswordVisiblity}
						>
							<img src={eyeImage.src} alt={eyeImage.alt} />
						</button>
					</div>
				);
			case 'select':
				return (
					<div className="input-container">
						<Select
							className="input-group dropdown"
							classNamePrefix="input-group"
							placeholder={placeholder}
							options={options}
							isSearchable={false}
							onChange={(event) => handleOnChange(event)}
							id={id}
							name={name}
							value={
								options?.find(
									(item: IOptions) => item.value === inputValue
								) || null
							}
						/>
						<span
							className={`floating-label ${
								!inputValue ? 'd-none' : ''
							}`}
						>
							{placeholder}
						</span>
					</div>
				);
			case 'otp':
				return (
					<div className="input-container otp">
						<input
							id={id}
							maxLength={6}
							placeholder={placeholder}
							name={name}
							onChange={(event) => handleOnChange(event.target.value)}
							value={inputValue}
							disabled={isDisabled}
						/>
						<span className="floating-label">{placeholder}</span>
					</div>
				);
			case 'currency':
				return (
					<div className="input-container">
						<input
							id={id}
							className="input-group prefix-addon"
							placeholder={placeholder}
							name={name}
							onChange={(event) => handleOnChange(event.target.value)}
							disabled={isDisabled}
							value={inputValue}
						/>
						<span className="floating-label">{placeholder}</span>
						<span className="prefix">Rp</span>
					</div>
				);
			case 'number':
				return (
					<div className="input-container">
						<input
							id={id}
							className="input-group"
							placeholder={placeholder}
							name={name}
							onChange={(event) => handleOnChange(event.target.value)}
							disabled={isDisabled}
							value={inputValue}
						/>
						<span className="floating-label">{placeholder}</span>
					</div>
				);
			case 'multi-select':
				return (
					<div className="input-container">
						<Select
							className="input-group dropdown"
							classNamePrefix="input-group"
							placeholder={placeholder}
							options={options}
							isMulti
							isSearchable={false}
							closeMenuOnSelect={false}
							hideSelectedOptions={false}
							onChange={(event) => handleOnChange(event)}
							id={id}
							components={{
								Option
							}}
							name={name}
							value={multiSelectValue.optionSelected}
						/>
						<span
							className={`floating-label ${
								!inputValue ? 'd-none' : ''
							}`}
						>
							{placeholder}
						</span>
					</div>
				);
			case 'datePicker':
				return (
					<div className="input-container">
						<DatePicker
							selectsRange
							className="input-group input-group-wide"
							dateFormat="dd/MMM/yyy"
							placeholderText={placeholder}
							startDate={startDate}
							endDate={endDate}
							onChange={(update) => {
								setDateRange(update);
								handleOnChange(update);
							}}
							disabledKeyboardNavigation
						/>
							<div className="rightIcon">
								<img
									src={ImagePath.calendar.src}
									alt={ImagePath.calendar.alt}
								/>
							</div>
						{endDate && (
						<span className="floating-label">
							{placeholder}
						</span>
						)}
					</div>
				);
			default:
				return (
					<div className="input-container">
						<input
							id={id}
							className="input-group"
							placeholder={placeholder}
							name={name}
							onChange={(event) => handleOnChange(event.target.value)}
							disabled={isDisabled}
							value={inputValue}
						/>
						<span className="floating-label">{placeholder}</span>
					</div>
				);
		}
	}

	return (
		<div>
			{loading ? <ShimmeringLoading height={54} /> : switchForm(formType)}
			{(error || apiErrorMessage) && (
				<div className="error-container">
					<img
						src={ImagePath.redWarning.src}
						alt={ImagePath.redWarning.alt}
					/>
					<span className="error-message">
						{errorMessage || apiErrorMessage}
					</span>
				</div>
			)}
		</div>
	);
};

export default InputComponent;
